/**
 * @file オプション設定
 */
'use strict';
// utility class

/**
 * @classname SelectSkuView
 * @classdesc オプションモーダル
 */
export default class SelectSkuView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - コントローラー
	 */
	constructor($e, controller) {
		console.log('SelectSkuView.constructor');
		this._$e = $e;
		this._sku = $e.attr('data-sku');
		$('[data-form=form-cart]').addClass('disabled');
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバックイベント
	 *
	 * @memberof SelectSkuView
	 * @return {undefined}
	 */
	onClick() {
		console.log('SelectSkuView.onClick');
		$('.btn-select-sku').text('選択する').removeClass('selected');
		this._$e.text('選択中').addClass('selected');
		$('[data-form=form-cart]').removeClass('disabled');
		$('#sku').val(this._sku);
	};
}
